<template>
  <div class="vx-row mb-2">
    <div class="vx-col w-full">
      <vs-divider>{{fieldLabel}}</vs-divider>

      <vs-row class="p-2">
        <vs-col
          class="font-semibold p-2"
          vs-type="flex"
          :vs-w="structure.width"
          v-for="(val,id) in structure.data"
          :key="id"
        >
          <vs-checkbox v-model="selected" :vs-value="val">{{val}}</vs-checkbox>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template> 
<script>
import { helperMixin } from "../../../mixin/helperMixin";
import { sidebarMixin } from "../sidebarMixin";
export default {
  components: {},
  mixins: [helperMixin,sidebarMixin],
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true,
    },
    value: String,
    validation: "",
  },
  data() {
    return {
      selected: this.thevalue,
      others: "",
      form: {
        fields: [],
      },
      test: true,
    };
  },
  computed: { 
    thevalue() {
      return this.capitalizeFirstLetter(this.value);
    },
  },
  methods: {
    changeHandler() {
      this.$emit("input", {
        index: this.index,
        value: this.others,
      });

      this.$validator.validateAll().then((result) => {
        this.$emit("error", { index: this.index, value: result });
      });
    },
  },
  created() {
    //we emit the default value because if user does not touch it won't be captured in the array
    this.$emit("input", { index: this.index, value: this.value });

    console.log("structure of checkbox:", this.structure.data);
    console.log("value:", this.value);

    //check for other's value
    if (this.value == undefined) {
      this.selected = []; //assigning the default value
      console.log("this.selected during add:", this.selected);
      this.$emit("error", { index: this.index, value: true });
      this.$emit("input", { index: this.index, value: this.structure.value });
    } else {
      //assigne the selected value
      this.selected = JSON.parse(this.value);
      console.log("this.selected during update:", this.selected);
    }

    //defined the watch method
    this.$watch("selected", (value) => {
      var errorVal = false;
      if (value != null) {
        errorVal = true;
        value = JSON.stringify(value);
      }
      value = this.replaceAll(value, this.index, "");
      console.log("value of checkbox:", value);

      this.$emit("error", { index: this.index, value: errorVal });
      this.$emit("input", { index: this.index, value: value });
    });
  },
};
</script>